export default __webpack_public_path__ + "static/media/LO01.7cba42ec.mp3";